<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-dialog :title="'合同签署'" :visible.sync="isShow" top="15px">
      <el-form :model="operateForm" :rules="rules" ref="operateForm" label-width="100px" class="demo-ruleForm" size="mini">
        <el-form-item label="当前用户" prop="cUser">
          <el-input v-model="operateForm.cUser" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="盖章类型" prop="signType">
          <el-input v-model="operateForm.signType" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="开启签署日期" prop="signatureShowTime">
          <el-switch v-model="signatureShowTime" active-color="#13ce66" inactive-color="#909399" :active-value="1" :inactive-value="0" @change="switchChange">
          </el-switch>
        </el-form-item>
        <el-form-item label="印章" prop="remark">
          <el-input v-model="operateForm.remark" :readonly="true" placeholder="请选择下方印章样式"></el-input>
        </el-form-item>
        <el-form-item label="印章ID" prop="signatureId" hidden="true">
          <el-input v-model="operateForm.signatureId" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="UUID" prop="conUuid" hidden="true">
          <el-input v-model="operateForm.conUuid" :readonly="true"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm('operateForm')">确定去签署</el-button>
      </div>
      <div class="demo-image" style="height: 200px; overflow-y: scroll;">
        <el-radio-group v-for="item in sealList" v-model="radio" :key="item.signature_id" @change="getSealId(item)">
          <el-image style="width: 100px; height: 100px" :src="'data:image/png;base64,' + item.signature_img_base64" @click="getSealId(item)">
            <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
          </el-image>
          <div><el-radio :label="item.remark"></el-radio></div>
        </el-radio-group>
      </div>
    </el-dialog>
    <el-tab-pane label="待我方签" name="first">
      <cont-sign-table
        :tableData="tableData"
        :tableLabel="tableLabel"
        :config="config"
        @changePage="changePage1"
        @view="viewContract"
        @sign="editSign"
        @complete="completeCon"
        @del="delCont"
        @qfSign="editQfSign"
      >
      </cont-sign-table>
    </el-tab-pane>
    <el-tab-pane label="待他方签" name="second">
      <cont-sign-table
        :tableData="tableData"
        :tableLabel="tableLabel"
        :config="config"
        @changePage="changePage2"
        @view="viewContract"
        @sign="editSign"
        @del="delCont"
        @complete="completeCon"
      >
      </cont-sign-table>
    </el-tab-pane>
    <el-tab-pane label="签署完成" name="third">
      <cont-preview-table :tableData="tableData" :tableLabel="tableLabel" :config="config" @changePage="changePage3" @view="viewContract"> </cont-preview-table>
    </el-tab-pane>
    <el-tab-pane label="全部合同" name="fourth"
      ><cont-preview-table :tableData="tableData" :tableLabel="tableLabel" :config="config" @changePage="changePage4" @view="viewContract"> </cont-preview-table
    ></el-tab-pane>
    <!-- <el-tab-pane label="草稿" name="fifth">草稿</el-tab-pane> -->
  </el-tabs>
</template>

<script>
import ContSignTable from '../../components/ContSignTable'
import { viewContractApi } from '../../api/getData'
import ContPreviewTable from '../../components/ContPreviewTable'
import { pageContractSendInfoApi } from '../../api/getData'
import { getSignPageApi } from '../../api/getData'
import { delSendContUserApi } from '../../api/getData'
import { getCurrentOrganizationApi } from '../../api/getData'
import { getAllSealApi } from '../../api/getData'
import { completeSendContUserApi } from '../../api/getData'
import { getQfSignPageApi } from '../../api/getData'
let tabname = 'first'

export default {
  components: {
    ContSignTable,
    ContPreviewTable
  },
  data() {
    return {
      radio: '',
      activeName: 'first',
      currentUser: '',
      isShow: false,
      signatureShowTime: 1,
      sealList: [
        {
          signature_id: '',
          signature_img_base64: '',
          signature_type: ''
        }
      ],
      tableData: [
        {
          contractId: '',
          contName: '',
          partyaMobile: '',
          partybMobile: ''
        }
      ],
      tableLabel: [
        {
          prop: 'contractName',
          label: '合同名称',
          width: 400
        },
        {
          prop: 'partyaMobile',
          label: '发起方账号',
          width: 120
        },
        {
          prop: 'realnameA',
          label: '发起方名称',
          width: 200
        },
        {
          prop: 'realnameB',
          label: '接收方名称',
          width: 200
        },
        {
          prop: 'createTime',
          label: '发起时间',
          width: 200
        },
        {
          prop: 'contractId',
          label: '合同编号',
          width: 180
        },
        {
          prop: 'bgNo',
          label: '变更编号',
          width: 180
        }
      ],
      operateForm: {
        contractId: '',
        customerId: '',
        cUser: '',
        signatureId: '',
        remark: '',
        conUuid: '',
        signType: '',
        signatureShowTime: ''
      },
      rules: {
        remark: [{ required: true, message: '请选择印章', trigger: 'blur' }]
      },
      // operateFormLabel: [
      //   {
      //     model: 'signKeyword',
      //     label: '签署关键字',
      //     type: 'select',
      //     options: [
      //       {
      //         label: '我是甲方(采购方/合同接收方)signature1',
      //         value: 'signature1'
      //       },
      //       {
      //         label: '我是乙方(生产方/合同发起方)signature2',
      //         value: 'signature2'
      //       }
      //     ]
      //   }
      // ],

      operateFormLabel: [
        {
          model: 'cUser',
          label: '当前用户',
          prop: 'cUser',
          readonly: true
        },
        {
          model: 'signType',
          prop: 'signType',
          label: '盖章类型',
          readonly: true
        },
        {
          model: 'signatureShowTime',
          prop: 'signatureShowTime',
          label: '开启签署日期'
        },
        {
          model: 'signatureId',
          prop: 'signatureId',
          label: '印章ID',
          readonly: true,
          placeholder: '以下印章ID'
        },
        {
          model: 'remark',
          prop: 'remark',
          label: '印章',
          readonly: true,
          placeholder: '以下印章'
        }
      ],
      config: {
        page: 1,
        size: 10,
        total: 0,
        loading: false
      }
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.name === 'first') {
        this.getList('0', '')
      }
      if (tab.name === 'second') {
        this.getList('', '0')
      }
      if (tab.name === 'third') {
        this.getList('1', '1')
      }
      if (tab.name === 'fourth') {
        this.getList('', '')
      }
      tabname = tab.name
    },

    getTabList(tabname) {
      if (tabname === 'first') {
        this.getList('0', '')
      }
      if (tabname === 'second') {
        this.getList('', '0')
      }
      if (tabname === 'third') {
        this.getList('1', '1')
      }
      if (tabname === 'fourth') {
        this.getList('', '')
      }
    },
    getList(isSignA, isSignB) {
      this.config.loading = true
      this.config.size = 10
      // 搜索时，页码需要设置为1，才能正确返回数据，因为数据是从第一页开始返回的
      //isSignA ? (this.config.page = 1) : ''
      //let isSignA = '' //发起方签署状态
      //let isSignB = '' //接收方签署状态
      //调用查询接口
      pageContractSendInfoApi(this.config.page, this.config.size, this.currentUser, isSignA, isSignB).then(res => {
        res = res.data
        this.tableData = res.data
        this.config.total = res.total
        this.config.size = res.pageSize
        this.config.loading = false
      })
    },
    editSign(row) {
      this.isShow = true
      console.info(row.organizationA)
      //var username = window.localStorage.getItem('mobile')
      getCurrentOrganizationApi().then(res => {
        res = res.data
        if (row.organizationA === res.data) {
          this.operateForm.cUser = '我是合同发起方（乙方）'
        } else {
          this.operateForm.cUser = '我是合同接收方（甲方）'
        }
      })
      this.operateForm.contractId = row.contractId
      this.operateForm.conUuid = row.conUuid
      this.operateForm.signType = '合同章'
      this.operateForm.signatureShowTime = 1
      if (row.bgNo) {
        row.contractId = row.contractId + row.bgNo
      }
      this.getAllSealList()
      //this.operateForm = row
    },
    //骑缝章
    editQfSign(row) {
      this.isShow = true
      console.info(row.organizationA)
      //var username = window.localStorage.getItem('mobile')
      getCurrentOrganizationApi().then(res => {
        res = res.data
        if (row.organizationA === res.data) {
          this.operateForm.cUser = '我是合同发起方（乙方）'
        } else {
          this.operateForm.cUser = '我是合同接收方（甲方）'
        }
      })
      this.operateForm.contractId = row.contractId
      this.operateForm.conUuid = row.conUuid
      this.operateForm.signType = '骑缝章'
      if (row.bgNo) {
        row.contractId = row.contractId + row.bgNo
      }
      this.getAllSealList()
      //this.operateForm = row
    },
    delCont(row) {
      //console.info(row)
      this.$confirm('此操作将删除该合同, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delSendContUserApi(row.contractId, row.fileId).then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getTabList(tabname)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //合同完成提交
    completeCon(row) {
      this.$confirm('是否盖章完成，确定提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.config.loading = true
          completeSendContUserApi(row.contractId, row.conUuid).then(res => {
            res = res.data
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getTabList(tabname)
            this.config.loading = false
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    //获取所有印章图片
    getAllSealList() {
      console.info('h获取印章列表')
      getAllSealApi().then(res => {
        res = res.data
        if (res.code == 1) {
          this.sealList = res.data
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
    },
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //调用合同签署api
          if (this.operateForm.signType == '合同章') {
            getSignPageApi(this.operateForm).then(res => {
              res = res.data
              console.info(res)
              if (res.code == 0) {
                console.info(res.data)
                window.location.href = res.data
                //window.open(res.data) //打开新界面
                this.isShow = false
              } else {
                this.$message({
                  type: 'warning',
                  message: res.msg + '当前用户无权限访问'
                })
              }
            })
          } else {
            this.isShow = false
            this.config.loading = true
            getQfSignPageApi(this.operateForm).then(res => {
              res = res.data
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: res.data
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: res.msg + '操作失败'
                })
              }
              this.getTabList(tabname)
              this.config.loading = false
            })
          }
        } else {
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          return false
        }
      })
    },
    viewContract(row) {
      console.info(row)
      viewContractApi(row.contractId, row.organizationA, row.organizationB, row.conUuid).then(res => {
        res = res.data
        if (res.code == 0) {
          window.open(res.data)
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
    },
    getSealId(item) {
      this.operateForm.signatureId = item.signature_id
      this.operateForm.remark = item.remark
      this.radio = item.remark
    },

    switchChange(value) {
      this.operateForm.signatureShowTime = value
    },

    changePage1(val) {
      this.config.page = val
      this.getList('0', '')
    },
    changePage2(val) {
      this.config.page = val
      this.getList('', '0')
    },
    changePage3(val) {
      this.config.page = val
      this.getList('1', '1')
    },
    changePage4(val) {
      this.config.page = val
      this.getList('', '')
    }
  },
  created() {
    this.currentUser = window.localStorage.getItem('mobile')
    this.getList('0', '')
  }
}
</script>

<style lang="scss" scoped></style>
